<skl-dialog-content-ins [isReady]="viewModel.isFormReady">
	<skl-dialog-header-ins
		[title]="'scenes.configuration.shared.numberings.dialog.title' | translate"
		id="numbering-dialog-header"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
		<skl-form-container>
			@if (viewModel.isFormReady) {
				<div class="grid" [sklValidationSource]="viewValidation">
					<div class="col-1">
						<ins-checkbox
							id="numbering-dialog-default"
							[(ngModel)]="viewModel.bo.model.default"
							[label]="'scenes.configuration.shared.numberings.dialog.form.default.label' | translate "
							[sklValidate]="getValidationKey('default')">
						</ins-checkbox>
					</div>
					<div class="col-1 align--medium-top">
						<ins-checkbox
							id="numbering-dialog-active"
							[(ngModel)]="viewModel.bo.model.active"
							[label]="'scenes.configuration.shared.numberings.dialog.form.active.label' | translate "
							[sklValidate]="getValidationKey('active')">
						</ins-checkbox>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.numberings.dialog.form.name.label' | translate">
							<ins-input
								[skl-focus-by]
								id="numbering-dialog-name"
								[(ngModel)]="viewModel.bo.model.name"
								[placeholder]="'scenes.configuration.shared.numberings.dialog.form.name.placeholder' | translate"
								[sklValidate]="getValidationKey('name')">
							</ins-input>
						</ins-form-field>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.numberings.dialog.form.documentKinds.label' | translate">
							<ins-select
								display-text="label"
								id="numbering-dialog-document-kind"
								[placeholder]="'ui.placeholders.empty' | translate"
								[converter]="viewModel.documentKindsConverter"
								[(ngModel)]="viewModel.documentKind.value"
								[sklValidate]="getValidationKey('kinds')">
								@for (item of viewModel.documentKinds; track item) {
									<ins-option
										[value]="item">
										{{item.label}}
									</ins-option>
								}
							</ins-select>
						</ins-form-field>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.numberings.dialog.form.kind.label' | translate">
							<ins-select
								display-text="label"
								id="numbering-dialog-format-type"
								[placeholder]="'ui.placeholders.empty' | translate"
								[(ngModel)]="viewModel.formatType"
								[readonly]="viewModel.isFormatTypeReadonly()"
								(ngModelChange)="viewModel.onFormatTypeChange()">
								@for (item of viewModel.formatTypes; track item) {
									<ins-option
										[value]="item">
										{{item.label}}
									</ins-option>
								}
							</ins-select>
						</ins-form-field>
					</div>
					@if (viewModel.bo.model.manual) {
						<div
							class="col-1"
							id="numbering-dialog-manual-numbering-inline-warning-text">
							<div class="notification-container">
								<skl-icon name="exclamation-triangle" class="text--warning"></skl-icon>
								<div class="notification-container--text">
									{{ 'scenes.configuration.shared.numberings.dialog.form.kind.warnings.manual' | translate }}
								</div>
							</div>
						</div>
					}
					<div class="col-1" [ngClass]="{'display--none': !viewModel.isAdditionalSymbolShown()}">
						<ins-form-field
							[label]="'scenes.configuration.shared.numberings.dialog.form.additional-symbol.label' | translate">
							<ins-input
								[(ngModel)]="viewModel.additionalSymbol"
								id="numbering-dialog-additional-symbol"
								(ngModelChange)="viewModel.onAdditionalSymbolChange()"
								[placeholder]="'scenes.configuration.shared.numberings.dialog.form.additional-symbol.placeholder' | translate"
								[sklValidate]="getValidationKey('additionalSymbol')">
							</ins-input>
						</ins-form-field>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.numberings.dialog.form.format.label' | translate">
							<ins-input
								[(ngModel)]="viewModel.bo.model.format"
								id="numbering-dialog-format"
								[readonly]="viewModel.isFormatReadonly()"
								[placeholder]="'scenes.configuration.shared.numberings.dialog.form.format.placeholder' | translate"
								[sklValidate]="getValidationKey('format')">
							</ins-input>
							<span slot="end">
								<skl-help-in-place
									[data]="viewModel.getNumberingAutotextsHintobxData">
								</skl-help-in-place>
							</span>
						</ins-form-field>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.numberings.dialog.form.starting-number.label' | translate">
							<ins-input
								inputmode="decimal"
								id="numbering-dialog-starting-number"
								rtl="false"
								[precision]="0"
								[(ngModel)]="viewModel.bo.model.startingNumber"
								[sklValidate]="getValidationKey('startingNumber')">
							</ins-input>
						</ins-form-field>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.numberings.dialog.form.gap-filling-method.label' | translate">
							<ins-select
								display-text="label"
								id="numbering-dialog-gap-filling-method"
								[(ngModel)]="viewModel.bo.model.gapFillingMethod"
								[converter]="viewModel.gapFillingMethodsConverter"
								[sklValidate]="getValidationKey('gapFillingMethod')">
								@for (item of viewModel.gapFillingMethods; track item) {
									<ins-option
										[value]="item">
										{{item.label}}
									</ins-option>
								}
							</ins-select>
						</ins-form-field>
					</div>
				</div>
			}
		</skl-form-container>
	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			id="numbering-dialog-cancel-button"
			(click)="onCancel()">
			{{ 'scenes.configuration.shared.base.dialog.buttons.cancel' | translate }}
		</skl-button>
		<skl-button
			typeName="accent"
			id="numbering-dialog-save-button"
			[spinner]="viewModel.isSaving"
			(click)="onConfirmAsync()">
			{{ 'scenes.configuration.shared.base.dialog.buttons.save' | translate }}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>